class PressReleaseFilter {
  constructor() {
    // Bind class methods
    this.handleFilter = this.handleFilter.bind(this);
    this.init = this.init.bind(this);
    this.renderListItem = this.renderListItem.bind(this);

    document.addEventListener('DOMContentLoaded', this.init);
  }

  init() {
    // Bind DOM elements
    this.select = document.querySelector('[data-ui="press-release-filter"]');
    this.output = document.querySelector('[data-ui="press-release-output"]');
    this.clearBtn = document.querySelector('[data-ui="search-clear"]');
    this.loadMoreBtn = document.querySelector('[data-ui="press-release-more"]');
    this.loadingMessage = document.querySelector(
      '[data-ui="press-release-loading"]'
    );
    this.emptyMessage = document.querySelector(
      '[data-ui="press-release-empty"]'
    );

    if (this.select) {
      if (!this.select.value) {
        this.select.value = 'corporate';
      }

      this.select.addEventListener('change', this.handleFilter);

      this.setupSites();
      this.fetchData();
    }
  }

  setupSites() {
    const apiSettings = window.WP_API_Settings;

    if (!apiSettings) {
      return;
    }

    const { hostname } = window.location;
    const isCorporate =
      hostname.startsWith('arch') || hostname.startsWith('www.arch');
    const unprefixedHost = hostname.replace('www.', '');
    const baseUrl = isCorporate
      ? unprefixedHost
      : unprefixedHost
          .split('.')
          .slice(1)
          .join('.');
    const apiUrl = `${baseUrl}/wp-json/`;
    const [rootSegment] = hostname.split('.');
    const currentSegment = isCorporate ? 'corporate' : rootSegment;
    const rootUrl = isCorporate
      ? apiSettings.root.replace('https://arch', 'https://www.arch')
      : apiSettings.root;
    const prefixedApiUrl = apiUrl.startsWith('www')
      ? `//${apiUrl}`
      : `//www.${apiUrl}`;
    const segments = ['corporate', 'mortgage', 'insurance', 'reinsurance'];
    const segmentSites = segments.reduce((sites, segment) => {
      if (segment === currentSegment) {
        sites[segment] = new WPAPI({
          endpoint: rootUrl,
          nonce: apiSettings.nonce
        });

        return sites;
      }

      if (segment === 'corporate') {
        sites[segment] = new WPAPI({
          endpoint: prefixedApiUrl
        });
      } else {
        sites[segment] = new WPAPI({
          endpoint: `//${segment}.`.concat(apiUrl)
        });
      }

      return sites;
    }, {});

    this.sites = segmentSites;

    return this.sites;
  }

  get activeSite() {
    const { value } = this.select;

    return this.sites[value];
  }

  async fetchData() {
    this.posts = await this.activeSite
      .posts()
      .param('filter[meta_key]', 'insight_article_type')
      .param('filter[meta_value]', 'press-release')
      .perPage(5);

    this.renderResults(this.posts);
  }

  mapJoin(field, callback) {
    if (!field || !field.length) {
      return '';
    }

    return field.map(callback).join('');
  }

  formatDate(dateStr) {
    const dateOptions = {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric'
    };
    const date = new Date(dateStr).toLocaleDateString('en-US', dateOptions);

    return date;
  }

  renderListItem(post) {
    const { date, link, title } = post;
    const fields = {
      date: this.formatDate(date),
      link: link,
      title: title.rendered
    };

    return `
      <li class="acg-link-list__item">
        <time class="acg-link-list__item__date" datetime="${date}">${fields.date}</time>
        <a href="${fields.link}" class="acg-link-list__item__link">${fields.title}</a>
      </li>
      `;
  }

  renderResults(results, append = false) {
    const elements = results.map(this.renderListItem);
    const markup = elements.join('');

    this.toggleControls(results, markup);

    if (append) {
      this.output.insertAdjacentHTML('beforeend', markup);
    } else {
      this.output.innerHTML = markup;
    }
  }

  toggleControls(data, markup) {
    const callback = this.handleLoadMore.bind(this, data);

    if (data._paging && data._paging.next) {
      this.loadMoreBtn.onclick = callback;
      this.loadMoreBtn.style.cssText = 'display: block;';
    } else {
      this.loadMoreBtn.onclick = null;
      this.loadMoreBtn.style.cssText = '';
    }

    this.loadingMessage.style.cssText = 'display: none;';
    this.emptyMessage.style.cssText = markup ? '' : 'display: block;';
  }

  clearResults() {
    this.output.innerHTML = '';
    this.loadMoreBtn.style.cssText = '';
    this.emptyMessage.style.cssText = '';
    this.loadingMessage.style.cssText = 'display: block;';
  }

  async handleLoadMore(data) {
    const nextEndpoint = data._paging.next._options.endpoint;

    if (!nextEndpoint.startsWith('http')) {
      // Fixes issue with endpoint not matching active domain
      const [activeEndpoint] = this.activeSite._options.endpoint.split(
        '/wp-json/'
      );

      data._paging.next._options.endpoint = activeEndpoint.concat(nextEndpoint);
    }

    const request = await data._paging.next;

    this.renderResults(request, true);
  }

  async handleFilter(event) {
    event.preventDefault();

    if (this.select.value) {
      this.clearResults();
      this.fetchData();
    } else {
      this.renderResults([]);
    }
  }
}

export default PressReleaseFilter;
